<!--
*    1. title -> checkbox group的title
*    2. filterData -> 顯示的checkbox有哪些，格式為[{name: String, val: String},{name: String, val: String},...]
*    3. v-model回傳每個checkbox的val [val, val,...]

-->

<template>
  <div class="c8-select">
    <div class="c8-select__title">
      <span class="c8-select__text">{{ title }}:</span>
    </div>
    <div class="c8-select__content">
      <div
        v-for="(item, index) in filterData"
        :key="`${item}_${index}`"
        class="checkbox c8-select__content__item"
        :class="{ active: checkList.includes(item.val)}"
        @click="pushVal(item.val)"
      >
        <i class="checkbox__select"></i>
        <label class="checkbox__label" for="">{{ item.name }}</label>
      </div>
    </div>
    <template v-if="buttonType === '1'">
      <div class="group-btn c8-select__content__item">
        <div class="button-outline group-btn__item" @click="checkAll">
          <span class="button-outline__text">全选</span>
        </div>
        <div class="button-outline group-btn__item" @click="clearAll">
          <span class="button-outline__text">清空</span>
        </div>
      </div>
    </template>
    <template v-if="buttonType === '2'">
      <div class="group-btn c8-select__content__item">
        <div class="button-primary disable item" @click="clearAll">
          <span class="button-primary__text">还原</span>
        </div>
      </div>
    </template>
    <template v-if="buttonType === '3'">
      <div class="group-btn c8-select__content__item">
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SMCheckBoxGroup',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      reruire: false,
      default: () => ''
    },
    filterData: {
      type: Array,
      require: true,
      default: () => []
    },
    buttonType: {
      type: String,
      reruire: false,
      default: () => '1'
    }
  },
  data() {
    return {
      checkList: this.setDefaultCheckItem()
    }
  },
  methods: {
    pushVal(val) {
      if (this.checkList.includes(val)) {
        this.checkList = this.checkList.filter(item => item !== val)
      } else {
        this.checkList.push(val)
      }
      this.$emit('change', [...this.checkList])
    },
    setDefaultCheckItem() {
      const defaultCheckItem = []
      if (this.buttonType === '1') {
        this.filterData.forEach((element) => {
          defaultCheckItem.push(element.val)
        })
      }
      return defaultCheckItem
    },
    checkAll() {
      this.checkList = this.setDefaultCheckItem()
      this.$emit('change', [...this.checkList])
    },
    clearAll() {
      this.checkList = []
      this.$emit('change', [...this.checkList])
    }
  }
}
</script>

<style lang="scss" scoped>
.c8-select__content {
  &/deep/ {
    .checkbox {
      &:hover {
        .el-checkbox__inner {
          border-color: #178aff;
        }
        .el-checkbox__label {
          color: #178aff;
        }
      }
    }
    .el-checkbox {
      margin-right: 8px;
      color: #000000;
    }
    // 來自 設計的 checkbox__select
    .el-checkbox__inner {
      width: 1rem;
      height: 1rem;
      border: solid 1px #EBEBEB;
      margin: 0 8px;
      border-radius: 2px;
      background-color: #ffffff;
    }
    .is-checked {
      .el-checkbox__inner {
        background-image: require('/assets/img/checkbox-v.svg');
        background-repeat: no-repeat;
        background-size: contain;
        border-color: #178aff;
        background-color: #178aff;
        &::after {
          border: 2px solid #fff;
          border-left: 0;
          border-top: 0;
          height: 8px;
          left: 5px;
        }
      }
    }
    .el-checkbox__label {
      padding: 0;
      font-size: 0.875rem;
      line-height: 0.875rem;
    }
  }
}
</style>
